import React, { PureComponent } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
export default class ChartBar extends PureComponent<any, {}> {
    UNSAFE_componentWillReceiveProps() {}
    render() {
        return (
            <ResponsiveContainer width="100%" height={300}>
                <BarChart
                    height={300}
                    width={500}
                    data={this.props.data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip
                        separator=""
                        // content={
                        //     //@ts-ignore
                        //     <this.CustomizedTooltip />
                        // }
                        // wrapperStyle={{ backgroundColor: "red" }}
                        // labelStyle={{ color: "green" }}
                        // itemStyle={{ color: "cyan" }}
                        formatter={function (value, name, props) {
                            // return [`${value} %`, "formatted name"];
                            return [`${value} - Terbitan`];
                        }}
                        labelFormatter={function (value) {
                            return `${value}`;
                        }}
                    />
                    <Bar dataKey="value" fill="#82ca9d" />
                </BarChart>
            </ResponsiveContainer>
        );
    }
}
